/**
 * Stored preferences for optional processing (first-party analytics, third-party scripts).
 * Values live in localStorage (not HttpOnly cookies) so the SPA can read them synchronously.
 * Auth refresh cookies are separate and always required for logged-in sessions.
 *
 * Module filename avoids "privacy"/"cookie"/"consent" so dev URLs are not blocked by filter lists.
 */

export const COOKIE_CONSENT_STORAGE_KEY = 'rms_cookie_consent_v1'
export const CONSENT_VERSION = 1

/**
 * @returns {{ v: number, decided: boolean, analytics: boolean, thirdParty: boolean, updatedAt?: number } | null}
 */
export function readCookieConsent() {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
    if (!raw) return null
    const o = JSON.parse(raw)
    if (o.v !== CONSENT_VERSION) return null
    return {
      v: o.v,
      decided: !!o.decided,
      analytics: !!o.analytics,
      thirdParty: !!o.thirdParty,
      updatedAt: o.updatedAt,
    }
  } catch {
    return null
  }
}

export function writeCookieConsent(payload) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(payload))
  } catch {
    /* quota / private mode */
  }
}

/** Synchronous gates for services/composables outside Pinia setup. */
export function allowsPublicAnalyticsSync() {
  const s = readCookieConsent()
  return !!(s?.decided && s?.analytics)
}

export function allowsThirdPartySync() {
  const s = readCookieConsent()
  return !!(s?.decided && s.thirdParty)
}
